import React from 'react';
import { TextFieldProps } from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import SvgIcon from '@material-ui/core/SvgIcon';
import format from 'date-fns/format';

import { useStyles } from './styles';
import { ReactComponent as DateRangeIcon } from 'assets/icons/calendar-icon.svg';
import { useTranslation } from 'hooks/useTranslation';
import i18n from 'locales/i18n';

export const DateField = ({
  inputRef,
  onClick,
  value,
  labelFormat = 'MMM do yyyy',
}: TextFieldProps & { labelFormat?: string }) => {
  const direction = i18n.dir();

  const classes = useStyles({ direction });
  const { t } = useTranslation();

  return (
    <div className={classes.dateFieldContainer} onClick={onClick}>
      <SvgIcon fontSize="small" className={classes.calendarIcon}>
        <DateRangeIcon />
      </SvgIcon>
      <Typography color="textPrimary" className={classes.dateFieldText} ref={inputRef}>
        {(value as string) && format(new Date(value as string), labelFormat)}
      </Typography>
      {!value && <Typography variant="h6">{t('inputs.enter')}</Typography>}
    </div>
  );
};
